<template>
  <div class="institute">
    <common-layout>
      <div slot="header">
        <h3>技术转移示范机构</h3>
      </div>
      <div slot="container">
        <div class="institute-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>服务领域:</label>
          <el-select
            style="width: 140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>服务类别:</label>
          <el-select
            style="width: 140px"
            v-model="levelValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in properOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>经济性质:</label>
          <el-select
            style="width: 140px"
            v-model="economyValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in economyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label>行业性质:</label>
          <el-select
            style="width: 140px"
            v-model="tradeValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in industOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <label>单位类型:</label>
          <el-select style="width:140px" v-model="unitValue" clearable placeholder="全部" @change='search'>
            <el-option
              v-for="item in inittypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
        </div>
        <div class="institute-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="名称"
              align="center"
              prop="name"
            ></el-table-column>
            <el-table-column label="经营条件" align="center">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">{{
                  GetTarg(scope.row.manage)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="日期"
              align="center"
              prop="date_time"
            ></el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain"
                  >是</el-tag
                >
                <el-tag v-else type="danger" effect="plain">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button>-->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="机构名称" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="服务领域" prop="field">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.field"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="服务类别" prop="level">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.level"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in properOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="级别" prop="A018">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.A018"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="经济性质" prop="economy">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.economy"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in economyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="ruleForm.logo"
                  :src="imgUrl + ruleForm.logo"
                  class="img_border"
                  v-real-img="ruleForm.logo"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logo }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人类型" prop="corporation">
              <el-select
                multiple
                style="width: 100%"
                v-model="ruleForm.corporation"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in legalOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人内设机构" prop="equipped">
              <el-select
                multiple
                style="width: 100%"
                v-model="ruleForm.equipped"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in institutionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="行业性质" prop="trade">
              <el-select
                multiple
                style="width: 100%"
                v-model="ruleForm.trade"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in industOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成立日期" prop="A015">
              <el-date-picker
                style="width: 100%"
                :picker-options="pickerOptions"
                v-model="ruleForm.A015"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择成立日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位类型" prop="A016">
              <el-select
                style="width: 100%"
                v-model="ruleForm.A016"
                placeholder="请选择"
                @change="unitChange"
              >
                <el-option
                  v-for="item in inittypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-left: 10px">
            <el-select
              multiple
              style="width: 100%"
              v-model="ruleForm.A017"
              placeholder="请选择"
              :disabled="ruleForm.A016 == '003' ? false : true"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通讯地址" prop="detailed">
            <v-distpicker
              style="text-align: left"
              @selected="citySelected"
              :province="ruleForm.address.province.value"
              :city="ruleForm.address.city.value"
              :area="ruleForm.address.area.value"
            ></v-distpicker>
            <el-input
              style="margin-top: 10px"
              v-model="ruleForm.detailed"
              placeholder="请填写详细地址"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="主营业务" prop="A001">
              <el-select
                multiple
                :multiple-limit="3"
                style="width: 100%"
                v-model="ruleForm.A001"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in newOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否国家高新区内机构"
              prop="gjgx"
              class="special"
              style="text-align: left"
            >
              <el-switch
                @change="swChange('A002', ruleForm.gjgx)"
                v-model="ruleForm.gjgx"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
              <el-input
                style="width: calc(100% - 98px); margin-left: 10px"
                :disabled="ruleForm.gjgx ? false : true"
                v-model="ruleForm.A002"
                placeholder="请填写所在高新区名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否科技服务体系试点区域机构"
              prop="kjfwsd"
              class="special"
              style="text-align: left"
            >
              <el-switch
                @change="swChange('A003', ruleForm.kjfwsd)"
                v-model="ruleForm.kjfwsd"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
              <el-input
                style="width: calc(100% - 98px); margin-left: 10px"
                :disabled="ruleForm.kjfwsd ? false : true"
                v-model="ruleForm.A003"
                placeholder="请填写试点高新区或城市名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否开展国际技术转移合作"
              prop="jszyhz"
              class="special"
              style="text-align: left"
            >
              <el-switch
                @change="swChange('A004', ruleForm.jszyhz, 1)"
                v-model="ruleForm.jszyhz"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
              <el-checkbox
                style="width: calc(100% - 98px); margin-left: 10px"
                v-model="ruleForm.A004"
                :true-label="1"
                :false-label="2"
                :disabled="ruleForm.jszyhz ? false : true"
                >国际技术转移占全部业务的50%以上</el-checkbox
              >
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="上一年度促成技术转移项目成交量(项)"
              prop="A005"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A005"
                placeholder="请填写促成技术转移项目成交量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="上一年度促成国际技术转移项目成交量(项)"
              prop="A006"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A006"
                placeholder="请填写促成国际技术转移项目成交量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="上一年度重大技术转移项目成交量(项)"
              prop="A007"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A007"
                placeholder="请填写重大技术转移项目成交量"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              label="上一年度促成技术转移项目成交金额(万)"
              prop="A008"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A008"
                placeholder="请填写促成技术转移项目成交金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="上一年度促成国际技术转移项目成交总金额(万)"
              prop="A009"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A009"
                placeholder="请填写促成国际技术转移项目成交总金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="上一年度重大技术转移项目成交总金额(万)"
              prop="A010"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A010"
                placeholder="请填写重大技术转移项目成交总金额"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="上一年度组织技术交易活动(次)"
              prop="A011"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A011"
                placeholder="请填写组织技术交易活动"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="上一年度组织技术转移培训(次)"
              prop="A012"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A012"
                placeholder="请填写组织技术转移培训"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="上一年度服务企业数量(家)"
              prop="A013"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A013"
                placeholder="请填写服务企业数量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="上一年度解决企业需求(项)"
              prop="A014"
              class="special"
            >
              <el-input
                v-model.number="ruleForm.A014"
                placeholder="请填写解决企业需求"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="实景图" style="text-align: center">
            <el-upload
              style="text-align: left"
              :action="this.uploadURL"
              list-type="picture-card"
              :file-list="fileList"
              :on-preview="pictureCardPreview1"
              :before-upload="beforeUpload1"
              :on-remove="handleRemove1"
              :http-request="HouImgFile1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="经营条件" prop="manage">
            <!-- <editor refName='manage' :placeholder="'请填写经营条件,比如办公面积,是否有独立网站,网址...'" :quill-data="ruleForm.manage" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor
              refName="manage"
              :placeholderText="'请填写经营条件,比如办公面积,是否有独立网站,网址...'"
              v-model="ruleForm.manage"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <!-- <el-row>
        <el-form-item label="上年度技术转移情况" prop="previous">
          	<editor refName='previous' :placeholder="'请填写上年度技术转移情况,比如促成技术转移项目成交数量,促成技术转移项目成交金额,服务企业数量,解决企业需求'" :quill-data="ruleForm.previous" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor>
        </el-form-item>
        </el-row>-->
        <el-row>
          <el-form-item label="技术转移模式" prop="characteristic">
            <!-- <editor refName='characteristic' :placeholder="'请填写技术转移及服务的模式与经营特色'" :quill-data="ruleForm.characteristic" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData2"></editor> -->
            <editor
              refName="characteristic"
              :placeholderText="'请填写技术转移及服务的模式与经营特色'"
              v-model="ruleForm.characteristic"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="技术转移现状" prop="work">
            <!-- <editor refName='work' :placeholder="'请填写技术转移及服务工作的现状'" :quill-data="ruleForm.work" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData3"></editor> -->
            <editor
              refName="work"
              :placeholderText="'请填写技术转移及服务工作的现状'"
              v-model="ruleForm.work"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="人员情况" prop="person">
            <editor
              refName="person"
              :placeholderText="'请填写人员情况'"
              v-model="ruleForm.person"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item style="text-align: left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐度" prop="hot_order">
              <!-- <el-input v-model.number="ruleForm.hot_order" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
              <el-slider
                v-model="ruleForm.hot_order"
                show-input
                :disabled="ruleForm.hot == 2"
              ></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import { DisabledDateFn } from "../../utils/tool";

export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      fieldValue: "",
      levelValue: "",
      economyValue: "",
      tradeValue: "",
      unitValue: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      type: 0,
      time: "",
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      options: [
        {
          value: "001",
          label: "成果转化中心",
        },
        {
          value: "002",
          label: "生产力促进中心",
        },
        {
          value: "003",
          label: "创业服务中心",
        },
        {
          value: "004",
          label: "大学科技园",
        },
        {
          value: "005",
          label: "科技咨询中心",
        },
        {
          value: "006",
          label: "科技信息所/中心",
        },
        {
          value: "007",
          label: "行业协会/学会",
        },
        {
          value: "008",
          label: "其它",
        },
      ],
      newOptions: [
        {
          value: "001",
          label: "技术集成与应用",
        },
        {
          value: "002",
          label: "技术中试与孵化",
        },
        {
          value: "003",
          label: "技术信息加工与整理",
        },
        {
          value: "004",
          label: "技术经营",
        },
        {
          value: "005",
          label: "技术（产权）交易",
        },
        {
          value: "006",
          label: "其它",
        },
      ],
      fieldOptions: [
        {
          value: "001",
          label: "新能源产业",
        },
        {
          value: "002",
          label: "新一代信息技术产业",
        },
        {
          value: "003",
          label: "生物产业",
        },
        {
          value: "004",
          label: "高端装备制造产业",
        },
        {
          value: "005",
          label: "新能源产业",
        },
        {
          value: "006",
          label: "新材料产业",
        },
        {
          value: "007",
          label: "新能源汽车产业",
        },
        {
          value: "008",
          label: "其它",
        },
      ],
      levelOptions: [
        {
          value: "001",
          label: "省级",
        },
        {
          value: "002",
          label: "国家级",
        },
      ],
      properOptions: [
        {
          value: "001",
          label: "专业服务类机构",
        },
        {
          value: "002",
          label: "综合服务类机构",
        },
      ],
      economyOptions: [
        {
          value: "001",
          label: "国有",
        },
        {
          value: "002",
          label: "集体",
        },
        {
          value: "003",
          label: "私营",
        },
        {
          value: "004",
          label: "其他",
        },
      ],
      industOptions: [
        {
          value: "001",
          label: "专业性",
        },
        {
          value: "002",
          label: "综合性",
        },
      ],
      inittypeOptions: [
        {
          value: "001",
          label: "科研机构",
        },
        {
          value: "002",
          label: "高等院校",
        },
        {
          value: "003",
          label: "科技中介机构",
        },
      ],
      legalOptions: [
        {
          value: "001",
          label: "企业法人",
        },
        {
          value: "002",
          label: "事业法人",
        },
        {
          value: "003",
          label: "社团法人",
        },
        {
          value: "004",
          label: "法人内设机构",
        },
      ],
      institutionOptions: [
        {
          value: "001",
          label: "无单独部门",
        },
        {
          value: "002",
          label: "已设立单独部门",
        },
        {
          value: "003",
          label: "预计未来一年内改制为独立法人",
        },
        {
          value: "004",
          label: "正在改制为独立法人",
        },
        {
          value: "005",
          label: "已改制为独立法人",
        },
      ],
      ruleForm: {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        field: [],
        level: [],
        economy: [],
        trade: [],
        A016: "",
        A017: [],
        A018: [],
        equipped: [],
        corporation: [],
        manage: "",
        // previous:'',
        characteristic: "",
        work: "",
        person: "",
        hot: 2,
        hot_order: 0,
        A001: [],
        gjgx: false,
        A002: "",
        kjfwsd: false,
        A003: "",
        jszyhz: false,
        A004: 2,
        A005: "",
        A006: "",
        A007: "",
        A008: "",
        A009: "",
        A010: "",
        A011: "",
        A012: "",
        A013: "",
        A014: "",
        A015: "",
        A016: "",
        // A017:'',
      },
      rules: {
        detailed: [
          {
            validator: (rule, value, callback) =>
              this.CheckAddress(rule, value, callback, this.ruleForm),
            required: true,
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        logo: [{ required: true, message: "请上传logo", trigger: "blur" }],
        A015: [
          { required: true, message: "请选择成立日期", trigger: "change" },
        ],
        field: [
          { required: true, message: "请选择服务领域", trigger: "change" },
        ],
        level: [
          { required: true, message: "请选择服务类别", trigger: "change" },
        ],
        economy: [
          { required: true, message: "请选择经济性质", trigger: "change" },
        ],
        trade: [
          { required: true, message: "请选择行业性质", trigger: "change" },
        ],
        A016: [
          { required: true, message: "请选择单位类型", trigger: "change" },
        ],
        corporation: [
          { required: true, message: "请选择法人类型", trigger: "change" },
        ],
        equipped: [
          { required: true, message: "请选择内设机构情况", trigger: "change" },
        ],
        manage: [
          { required: true, message: "请输入经营条件", trigger: "blur" },
        ],
        // previous:[{required: true, message: '请输入上年度技术转移情况', trigger: 'blur'}],
        characteristic: [
          { required: true, message: "请输入技术转移模式", trigger: "blur" },
        ],
        work: [
          { required: true, message: "请输入技术转移现状", trigger: "blur" },
        ],
        person: [
          { required: true, message: "请输入人员情况", trigger: "blur" },
        ],
        hot_order: [
          { required: true, validator: validateHoto, trigger: "blur" },
        ],
        A005: [
          {
            required: true,
            message: "请输入促成技术转移项目成交量",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A006: [
          {
            required: true,
            message: "请输入促成国际技术转移项目成交量",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A007: [
          {
            required: true,
            message: "请输入重大技术转移项目成交量",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A008: [
          {
            required: true,
            message: "请输入促成技术转移项目成交金额",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A009: [
          {
            required: true,
            message: "请输入促成国际技术转移项目成交总金额",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A010: [
          {
            required: true,
            message: "请输入重大技术转移项目成交总金额",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A011: [
          {
            required: true,
            message: "请输入组织技术交易活动",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A012: [
          {
            required: true,
            message: "请输入组织技术转移培训",
            trigger: "blur",
          },
          { type: "number", message: "请输入数字值" },
        ],
        A013: [
          { required: true, message: "请输入服务企业数量", trigger: "blur" },
          { type: "number", message: "请输入数字值" },
        ],
        A014: [
          { required: true, message: "请输入解决企业需求", trigger: "blur" },
          { type: "number", message: "请输入数字值" },
        ],
      },
    };
  },
  created() {
    // this.getData("Resource_Transfer?all=1&page=" + this.current_page);
    this.getData();
  },
  methods: {
    // release(row,type){
    //   let obj = {};
    //   obj.id = row.id;
    //   obj.type = 15;
    //   obj.hot = 1;
    // },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    unitChange(e) {
      if (e !== "003") {
        this.ruleForm.A017 = [];
      }
    },
    getData(url) {
      let params = {
        all: 1,
        page: this.current_page,
        name: this.searchValue,
        field: this.fieldValue || '',
        level: this.levelValue || '',
        economy: this.economyValue || '',
        trade: this.tradeValue || '',
        A016: this.unitValue || '',
      };

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-transfer/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //城市选择
    citySelected(e) {
      this.ruleForm.address = e;
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.manage = val;
    },
    // getQuillData1(val) {
    // 	this.ruleForm.previous = val;
    // },
    getQuillData2(val) {
      this.ruleForm.characteristic = val;
    },
    getQuillData3(val) {
      this.ruleForm.work = val;
    },
    getQuillData4(val) {
      this.ruleForm.person = val;
    },
    //切换清空
    swChange(val, e, type) {
      if (!e) {
        if (!type) {
          this.ruleForm[val] = "";
        } else {
          this.ruleForm[val] = 2;
        }
      }
    },
    //新增
    addEvent() {
      this.is_submit = true;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        field: [],
        level: [],
        A018: [],
        economy: [],
        trade: [],
        A016: "",
        A017: [],
        equipped: [],
        corporation: [],
        manage: "",
        // previous:'',
        characteristic: "",
        work: "",
        person: "",
        hot: 2,
        hot_order: 0,
        A001: [],
        gjgx: false,
        A002: "",
        kjfwsd: false,
        A003: "",
        jszyhz: false,
        A004: 2,
        A005: "",
        A006: "",
        A007: "",
        A008: "",
        A009: "",
        A010: "",
        A011: "",
        A012: "",
        A013: "",
        A014: "",
        A015: "",
        A016: "",
        // A017:'',
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-transfer/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData();
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.ResetSearch([
                    "searchValue",
                    "fieldValue",
                    "levelValue",
                    "economyValue",
                    "tradeValue",
                  ]);
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData(
        "Resource_Transfer?all=1&name=" +
          this.searchValue +
          "&page=" +
          this.current_page +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.levelValue ? "&level=" + this.levelValue : "") +
          (this.economyValue ? "&economy=" + this.economyValue : "") +
          (this.tradeValue ? "&trade=" + this.tradeValue : "") +
          (this.unitValue ? "&A016=" + this.unitValue : "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr?.join(",") || [];
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.detailed = row.address ? row.address.detailed : "";
      row.address = row.address
        ? row.address
        : { province: { value: "" }, city: { value: "" }, area: { value: "" } };
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.field = row.field?.split(",") || [];
      this.ruleForm.level = row.level?.split(",") || [];
      this.ruleForm.A018 = row.A018?.split(",") || [];
      this.ruleForm.economy = row.economy?.split(",") || [];
      this.ruleForm.trade = row.trade?.split(",") || [];
      this.ruleForm.A001 = row.A001?.split(",") || [];
      if (row.A002) {
        this.ruleForm.gjgx = true;
      } else {
        this.ruleForm.gjgx = false;
      }
      if (row.A003) {
        this.ruleForm.kjfwsd = true;
      } else {
        this.ruleForm.kjfwsd = false;
      }
      if (row.A004) {
        this.ruleForm.jszyhz = true;
      } else {
        this.ruleForm.jszyhz = false;
      }
      if (row.A017) {
        this.ruleForm.A017 = row.A017?.split(",") || [];
      }else{
        this.ruleForm.A017 = []
      }
      this.ruleForm.equipped = row.equipped?.split(",") || [];
      this.ruleForm.corporation = row.corporation?.split(",") || [];
      // this.ruleForm.detailed = row.address.detailed
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image?.split(",") || [];
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-transfer/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch([
                  "searchValue",
                  "fieldValue",
                  "levelValue",
                  "economyValue",
                  "tradeValue",
                ]);
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
        "Resource_Transfer?all=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.levelValue ? "&level=" + this.levelValue : "") +
          (this.economyValue ? "&economy=" + this.economyValue : "") +
          (this.tradeValue ? "&trade=" + this.tradeValue : "") +
          (this.unitValue ? "&A016=" + this.unitValue : "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
    factory(name) {
      this.$jsonp(
        "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.ruleForm.detailed +
          "&city=" +
          this.ruleForm.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
        .then((json) => {
          let arr = json?.pois[0]?.location?.split(",") || [];
          this.ruleForm.longitude = arr[0];
          this.ruleForm.latitude = arr[1];
          this.subData(name);
        })
        .catch((err) => {
          this.is_submit = true;
          console.error(err);
          this.$message.error("未获取到经纬度,请查看地址是否完整");
        });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data.store_result);
        } else {
          arr.push(item.store_result);
        }
      });
      obj.image = arr?.join(",") || "";
      obj.address.detailed = this.ruleForm.detailed;
      obj.field = this.ruleForm.field?.join(",") || "";
      obj.level = this.ruleForm.level?.join(",") || "";
      obj.A018 = this.ruleForm.A018?.join(",") || "";
      obj.economy = this.ruleForm.economy?.join(",") || "";
      obj.trade = this.ruleForm.trade?.join(",") || "";
      obj.A001 = this.ruleForm.A001?.join(",") || "";
      obj.A017 = this.ruleForm.A017?.join(",") || "";
      obj.equipped = this.ruleForm.equipped?.join(",") || "";
      obj.corporation = this.ruleForm.corporation?.join(",") || "";
      obj.date_time = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
        }
      });
      if (obj.hot == 2) {
        obj.hot_order = 0;
      }
      obj.previous = `<p>促成技术转移项目成交数量${obj.A005}项,其中促成国际技术转移项目成交数量${obj.A006}项,重大技术转移项目成交数量${obj.A007}项 </p>
                        <p>促成技术转移项目成交金额${obj.A008}万元,其中促成国际技术转移项目成交总金额${obj.A009}万元,重大技术转移项目成交总金额${obj.A010}万元</p>
                        <p>组织技术交易活动${obj.A011}次,组织技术转移培训${obj.A012}次</p>
                        <p>服务企业数量${obj.A013}家,解决企业需求${obj.A014}项</p>`;
      delete obj.detailed;
      delete obj.gjgx;
      delete obj.kjfwsd;
      delete obj.jszyhz;
      if (!this.ruleForm.id) {
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-transfer/create`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.ResetSearch([
                "searchValue",
                "fieldValue",
                "levelValue",
                "economyValue",
                "tradeValue",
              ]);

              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
              let obj1 = {
                name: obj.name,
                moudle: "技术转移示范机构",
                date_time: obj.date_time,
              };
              this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
      if (this.Title == "编辑") {
        // delete obj.id;
        obj.id = this.ruleForm.id;
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-transfer/update`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.ResetSearch([
                "searchValue",
                "fieldValue",
                "levelValue",
                "economyValue",
                "tradeValue",
              ]);

              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.logo = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传照片墙
    HouImgFile1(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scope>
.institute {
  height: 100%;
  width: 100%;
  .institute-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .el-select {
      margin: 0 15px;
      .el-input {
        margin: 0;
      }
    }
    /deep/.el-input--suffix {
      width: 100%;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .institute-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
